import React, { useEffect, useState } from 'react';
import ReportSidebar from './ReportSidebar';
import ReportList from './ReportList';
import ReportViewer from './ReportViewer';

const ReportsPage: React.FC = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <div className={`dashboard-main${isMobile ? ' reports-mobile-stack' : ''}`}>
      {isMobile ? (
        <div className="reports-mobile-bars">
          <ReportSidebar />
          <ReportList />
        </div>
      ) : (
        <ReportSidebar />
      )}
      <div className="dashboard-content">
        <div className="content-body">
          {!isMobile && <ReportList />}
          <ReportViewer />
        </div>
      </div>
    </div>
  );
};

export default ReportsPage; 